<div class="cm-landing-fixed-width">
	<h1>CropManage Terms of Use</h1>

	<h2>Disclaimer of Warranty</h2>

	<p>CropManage is provided "as is" without warranties of any kind, express or implied. CropManage generates
		irrigation, fertilization, and related agricultural recommendations based on user-submitted data,
		third-party data sources (e.g., weather and evapotranspiration data), and modeled estimates. These
		recommendations are intended as a decision-support tool and do not constitute professional agronomic advice.
		CropManage makes no warranty as to the accuracy, completeness, or reliability of any recommendation,
		calculation, or data displayed, whether originating from the web application or the API.
	</p>

	<p>Users are solely responsible for evaluating the accuracy of submitted data and for the final decisions made
		regarding irrigation, fertilization, or other agricultural practices. CropManage and its maintainers are not
		responsible for decisions made based on CropManage recommendations, calculations, software behavior, or data
		submitted through the API by any user or third party.
	</p>

	<h2>CropManage API Terms of Use</h2>

	<p>By requesting and using production access to the CropManage API, you agree to the following terms:</p>

	<h2>1. Access Revocation</h2>

	<p>Production API access is a privilege, not a right. UC ANR reserves the right to suspend or revoke API access
		at any time, for any reason, with or without prior notice.
	</p>

	<h2>2. Error Resolution</h2>

	<p>If your API integration generates errors, and you are notified of those errors by the CropManage team, you are
		required to address those errors within 14 business days of notification. Failure to do so may result in
		temporary suspension of your API access until the errors are resolved. CropManage reserves the right to
		suspend access immediately, without waiting for the resolution period, if errors are frequent, severe, or
		indicate a pattern of misuse.
	</p>

	<h2>3. Acknowledgment</h2>

	<p>Production API access will not be granted until you have provided written acceptance of these terms (e.g., by
		signed reply or other documented confirmation). By using the CropManage API in production, you acknowledge
		that you have read, understood, and agree to these terms.
	</p>
</div>
